import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { CloseIcon } from "../../shared/components/Icons";

type Props = {
  text: string;
  positiveResponse: (reason?: string) => void;
  cancel: () => void;
  isLoading: boolean;
  showModal: boolean;
  btnText?: string;
  reason?: string;
};

const CandidateMoveConfirmModal = ({
  text,
  positiveResponse,
  cancel,
  isLoading,
  showModal,
  btnText = "Move to next stage",
  reason = "",
}: Props) => {
  const [tempReason, setTempReason] = useState<string>(reason || "");
  useEffect(() => {
    setTempReason(reason);
  }, [reason]);

  const responseBtnClick = useCallback(() => {
    if (tempReason) {
      positiveResponse(tempReason);
    } else {
      positiveResponse();
    }
  }, [positiveResponse, tempReason]);
  return (
    <Dialog open={showModal} onClose={cancel} maxWidth="md">
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 4,
          my: 2,
        }}
      >
        <Grid container direction={"column"} item>
          <Typography
            fontSize={"24px"}
            lineHeight={"32px"}
            fontWeight={"700"}
            align="center"
          >
            {text}
          </Typography>
          {reason === "Other" && (
            <TextField
              multiline
              label="Mention Reason"
              variant="standard"
              sx={{
                mt: 2,
              }}
              autoFocus
              value={tempReason}
              onChange={(e) => setTempReason(e.target.value)}
              error={reason.length > 0 && tempReason.length === 0}
              helperText={
                reason.length > 0 &&
                tempReason.length === 0 &&
                "Reason cannot be empty"
              }
            />
          )}
          <Grid container justifyContent={"flex-end"} gap={1} item>
            <Button variant="text" sx={{ mt: 2 }} onClick={cancel}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
              onClick={responseBtnClick}
              disabled={
                isLoading || (reason.length > 0 && tempReason.length === 0)
              }
            >
              {isLoading ? (
                <CircularProgress size={20}></CircularProgress>
              ) : (
                btnText
              )}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CandidateMoveConfirmModal;
